import { render, staticRenderFns } from "./ConsentListIndex.vue?vue&type=template&id=40e4f484&scoped=true&"
import script from "./ConsentListIndex.vue?vue&type=script&lang=js&"
export * from "./ConsentListIndex.vue?vue&type=script&lang=js&"
import style0 from "./ConsentListIndex.vue?vue&type=style&index=0&id=40e4f484&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e4f484",
  null
  
)

export default component.exports